import { render, staticRenderFns } from "./ClassNewDialog.vue?vue&type=template&id=3df21ad0"
import script from "./ClassNewDialog.vue?vue&type=script&lang=js"
export * from "./ClassNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports